import React, {useState, useEffect} from "react";
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import {getPaymentIntent} from "../services/apiPaiement";
import {CheckoutForm} from "../components/CheckoutForm";

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is your test publishable API key.
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
if (!stripePublishableKey) throw new Error(
  'Stripe publishable key not found. Please set REACT_APP_STRIPE_PUBLIC_KEY in your .env file.'
)
const stripePromise = loadStripe(stripePublishableKey);

export const Paiement = () => {
	const [clientSecret, setClientSecret] = useState<any>("");

	useEffect(() => {
		// Create PaymentIntent as soon as the page loads
		const paymentIntent = async () => {
			const data = await getPaymentIntent();
			setClientSecret(data.clientSecret)
		}

		paymentIntent();
	}, []);

	const appearance = {
		theme: 'stripe' as "stripe" | "night" | "flat" | undefined,
		variables: {
			colorPrimary: '#885e02',
			colorBackground: '#ffffff',
			colorText: '#1b1301',
			colorDanger: '#ad2323',
			fontFamily: 'Lato, system-ui, sans-serif',			
			borderRadius: '10px',
			accordionItemSpacing: '16px',
		}
	};
	// Enable the skeleton loader UI for optimal loading.
	const loader = 'auto';

	return (
		<div>
			{clientSecret && (
				<Elements options={{clientSecret, appearance, loader}} stripe={stripePromise}>
					<CheckoutForm/>
				</Elements>
			)}
		</div>
	);
}